module.exports = __webpack_public_path__ + "img/samuelparot.973dd157.jpg";